<template>
        <header class="masthead">
        <div class="container d-flex h-100 align-items-center">
            
            <div class="mx-auto text-center mt-5">
                <img src="assets/myprofile.png" alt="">
                <h3 class="mt-4" style="font-family: 'Rubik', sans-serif !important; color: white;">Hi, I'm Miskah</h3>
                <h1 class="mx-auto my-0 text-white">Front-end Developer and<br> UI/UX Designer</h1>
                <a class="btn btn-primary js-scroll-trigger mt-5 text-uppercase" target="_blank" href="https://drive.google.com/file/d/1NLJiIrCU0cXl0_fx5PQgErdLOn0ey1x6/view?usp=sharing">Download CV</a>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'Header'
}
</script>

